import { render, staticRenderFns } from "./ErrorRegistrationModal.vue?vue&type=template&id=3cfa38f0&"
import script from "./ErrorRegistrationModal.vue?vue&type=script&lang=js&"
export * from "./ErrorRegistrationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports